import makeStyles from '@mui/styles/makeStyles';
import {get, isEmpty} from "lodash";
import React from 'react';
import {useTranslation} from "react-i18next";
import {color, font, space, type} from "common/tokens";
import useFreshData, {dataKeys} from "common/useFreshData";
import {useSetTranslation} from "common/useSetTranslation";
import SwipeCards from "components/SwipeCards";
import Skeleton from "components/redesign/Skeleton";

const useStyles = makeStyles(theme => ({
  page: {
    background: color.SURFACE,
    minHeight: '100%',
  },
  container: {
    maxWidth: space.CONTAINER_MAX,
    margin: '0 auto',
    padding: '48px 32px 64px',
    boxSizing: 'border-box',
    [theme.breakpoints.down('md')]: {
      padding: '24px 16px 48px',
    },
  },
  content: {
    width: 638,
    maxWidth: '100%',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
  },
  eyebrow: {
    ...type.eyebrow,
    fontWeight: font.BOLD,
    letterSpacing: '1.43px',
    color: color.SECTION_TITLE,
    margin: 0,
  },
  title: {
    ...type.pageTitle,
    color: color.TEXT,
    margin: '8px 0 0',
  },
  message: {
    ...type.body,
    fontSize: 16,
    color: color.TEXT_MUTED,
    margin: '14px 0 0',
  },
  cards: {
    marginTop: 32,
  },
  loading: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    marginTop: 32,
  },
}));

const isApplicationInReview = status =>
  get(status, 'experiences.matchingflow') === "use" &&
  get(status, 'experiences.matchingflowStatus.applicationReview') === "use";

const InactiveMentorshipLearning = ({mentorshipCards, ruleMessage, getMentorshipCards, status}) => {
  const classes = useStyles();
  const {t} = useTranslation();
  const {st} = useSetTranslation();

  useFreshData(dataKeys.MENTORSHIP_CARDS, getMentorshipCards);

  const message = isApplicationInReview(status)
    ? st(get(ruleMessage, 'applicationReview'), get(ruleMessage, 'localeApplicationReview'))
    : st(get(ruleMessage, 'curriculum'), get(ruleMessage, 'localeCurriculum'));

  return (
    <div className={classes.page}>
      <div className={classes.container}>
        <div className={classes.content}>
          <p className={classes.eyebrow}>{t('mentorship')}</p>
          <h1 className={classes.title}>{`${t('mentorship')} ${t('program')}`}</h1>
          {Boolean(message) && <p className={classes.message}>{message}</p>}

          {isEmpty(mentorshipCards) ? (
            <div className={classes.loading}>
              <Skeleton height={340}/>
            </div>
          ) : (
            <div className={classes.cards}>
              <SwipeCards cards={mentorshipCards}/>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default InactiveMentorshipLearning;
